import api from "./api";

const BASE_PATH = "/api/wo-tech-note";

const create = (data) => {
  return api.post(BASE_PATH, data);
};

const findAll = (woId) => {
  return api.get(BASE_PATH, {
    params: woId ? { woId } : undefined,
  });
};

const update = (id, data) => {
  return api.patch(`${BASE_PATH}/${id}`, data);
};

const TechNoteService = {
  create,
  findAll,
  update,
};

export default TechNoteService;
